<template>
    <div>
        <div class="chat-footer d-flex align-items-center position-relative">
            <textarea 
                id="message-input-chatroom"
                v-model="message" 
                @keyup.enter.exact="onSubmit" 
                @focus = "markAsSeen(room)"
                type="text"
                 wrap="physical" 
                placeholder="Type your message..."></textarea>
            <button 
                @click="onSubmit"
                class="position-absolute p-0"
                :disabled = "!message.trim()"
                id="send-message-chatroom"
                >
                    <Icon icon="send"/>
            </button>
        </div>
        <p v-if="errorMessage" class="position-absolute p1b error-state-texts">{{errorMessage}}</p>
    </div>
</template>

<script>
import { ref, onMounted, watch, computed } from '@vue/composition-api'
import { chatUseCase } from '../../../core/usecases'
import { useRouter, useStore, useUserId } from '../../../core/hooks'
import { event } from 'vue-analytics'
import { message as alertMessage} from 'ant-design-vue'
import Icon from '../../../components/Theme/Icon'

export default {
    components: {
        Icon
    },
    props: [
        'room'
    ],
    setup({ room }, context) {

        const message = ref('')
        const { route, router } = useRouter()
        const errorMessage = ref(null)
        const { store } = useStore()
        const user = computed(() => store.state.user)
        const isEcommercePlatform = computed(() => store.getters.isEcommercePlatform)
        const productType = isEcommercePlatform.value ? 
                { long: 'shops', short: 'shop' }:
                { long: 'campaigns', short: 'camp' }

        const markAsSeen = (room) => {
            chatUseCase.markRoomAsSeen(room)
        }

        const sendEvents =  () => {
            
            const ownerProductId = room[`${productType.long}`][0].split('_').filter(item => item !== room.contact_camp_id)[0]

            const mixpanelEventData = {
                'Sender User': user.value.email,
                [isEcommercePlatform.value ? 'Sender Shop' : 'Sender Campaign']: room[`${productType.short}-`+ownerProductId].name,
                [isEcommercePlatform.value ? 'Receiver Shop' : 'Receiver Campaign']: room[`${productType.short}-`+room.contact_camp_id].name,
                'Message Box Location': 'Chatroom'
            }

            if(!isEcommercePlatform.value) {
                mixpanelEventData['Update Date Added'] = false
            }
            
            context.root.$sendMixpanelEvent('Send Message', mixpanelEventData);

            let gaEventData  = `
                SenderUser: ${user.value.email},
                ${isEcommercePlatform.value ? 'SenderShop' : 'SenderCampaign'}: ${room[`${productType.short}-`+ownerProductId].name},
                 ${isEcommercePlatform.value ? 'ReceiverShop' : 'ReceiverCampaign'}: ${room[`${productType.short}-`+room.contact_camp_id].name},
                Location: Chatroom
            `

            if(!isEcommercePlatform.value) {
                gaEventData += 'UpdateDateAdded: false'
            }

            context.root.$ga.event('Chat', 'Send Message', gaEventData);

            context.root.$incrementMixpanelPeopleProperty('Sent Messages')
        }

        const onSubmit = () => {
            const newMessage = message.value.trim()
            if (!newMessage.length) {
                return
            }
            if(newMessage.length > 1200) {
                return alertMessage.error('You have reached your maximum limit of characters allowed (1200 symbols)', 3)
            }

            chatUseCase.sendMessage({
                roomId: room.id,
                partnerId: room.partnerId,
                message: newMessage,
            })


            sendEvents()
            
            message.value = ''
            for (let key in room) {
                if (room.hasOwnProperty(key) && key.startsWith(`${productType.short}-`) && !key.includes(room.contact_camp_id)){
                    event('Chat', 'Message Sent', room[key].name, 1)
                    break;
                }
            }
        }

        // auto send functionality

        onMounted(() => {
            const newMessage = route.value.query.message

            if (!newMessage) {
                return
            }

            chatUseCase.sendMessage({
                roomId: room.id,
                partnerId: room.partnerId,
                message: newMessage,
            })

            router.replace({ query: { ...route.value.query, message: undefined } }).catch(() => {})
        })

        return {
            message,
            onSubmit,
            errorMessage,
            markAsSeen
        }
    }
}
</script>

<style scoped lang="scss">
div.chat-footer {
    textarea {
        border: 1px solid #D6DDE3;
        box-sizing: border-box;
        border-radius: 12px;
        height: 64px;
        width: 100%;
        color: #9B9B9B;
        font-size: 16px;
        line-height: 24px;
        padding-left: 32px;
        padding-right: 56px;
        padding-top: 20px;
        padding-bottom: 20px;
        overflow: auto;
        &::-webkit-scrollbar {
            display: none;
            
        }
    }
    button {
        position: absolute;
        right: 10px;
        &:disabled img {
            opacity: 0.3
        }
    }
}
</style>